<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Indicadores Generales"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <app-figure title="Total PQR's">
                    {{ total }}
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="Completas">
                    {{ completed }}
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="Efectividad">
                    {{ performance | decimal(0) }}%
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="T. Prom. Resolución">
                    {{ resolutionTime | decimal(2) }} días
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="T. Prom. R. Cliente">
                    {{ completionTime | decimal(2) }} días
                </app-figure>
            </b-col>
            <b-col cols="12" md="4">
                <app-figure title="Prom. Mensual">
                    {{ monthAverage | decimal(0) }}
                </app-figure>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import reportingRepository from '../../../../../../repositories/reporting.repository';
import Figure from '../../../../../UI/Reports/Figure';
export default {
    components: {
        appFigure: Figure
    },
    data: () => ({
        resolutionTime: 0,
        completionTime: 0,
        total: 0,
        resolved: 0,
        completed: 0,
        closed: 0,
        performance: 0,
        monthAverage: 0
    }),
    methods: {
        async loadPqrsIndicators() {
            try {
                const rr = {...reportingRepository};
                const {data} = await rr.getPqrIndicators();
                this.resolutionTime = data.resolutionTime;
                this.completionTime = data.completionTime;
                this.total = data.total;
                this.resolved = data.resolved;
                this.completed = data.completed;
                this.closed = data.closed;
                this.performance = data.completed / data.total * 100;
                this.monthAverage = data.monthAverage.average;
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar los indicadores de las PQRs [${err.message}]`);
            }
        }
    },
    created() {
        this.loadPqrsIndicators();
    }
}
</script>
